import * as actionTypes from '../Action/Actiontypes';

const initialstate = {
    payment_plans: [],
    loading: false,
    error: false,
}

const PaymentReducer = (state = initialstate, action) => {
    switch (action.type) {
        case actionTypes.GET_PAYMENT_INIT:
            return {
                ...state,
                loading: true
            }

        case actionTypes.GET_PAYMENT_SUCCESS:
            return {
                ...state,
                payment_plans: action.payload,
                loading: false,
            }

        case actionTypes.GET_PAYMENT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
    
        default:
            return state;
    }
}

export default PaymentReducer;